import { authGetters, authMapGetters } from '@common/store/modules';
import { mapActions as reviewMapActions } from '@common/store/modules/review';
import * as reviewTypes from '@common/store/modules/review/types';

import { setKeyword, setProfile } from '@common/lib/common/utils';

export default {
  props: {
    review: Object,
    isCustomer: Boolean,
    option: {
      type: Object,
      default: () => {
        return {
          readOnly: false,
        };
      },
    },
    storeId: Number,
    isSearchPage: Boolean,
  },
  data(props) {
    return {
      choice: props.review.userChoice,
      likeCnt: props.review.likeCnt,
      hateCnt: props.review.hateCnt,
      reviewTypes: [],
    };
  },
  computed: {
    ...authMapGetters({
      curUser: authGetters.CURRENT_USER,
    }),
    loginUserId() {
      return this.option ? this.curUser.id : 0;
    },
  },
  created() {
    this.getReviewTypes();
  },
  methods: {
    ...reviewMapActions([reviewTypes.UPDATE_REVIEW_CHOICE_COUNT]),
    viewImage(urls, index) {
      this.$emit('view-image', urls, index);
    },
    fnLike() {
      if (this.choice === 'hate') {
        // 싫어요 선택이 되어 있을 경우 카운트 마이너스
        this.hateCnt = this.hateCnt - 1;
      }
      if (this.choice === 'like') {
        // 좋아요 선택이 되어있을 경우 카운트 마이너트, 선택취소
        this.choice = '';
        this.likeCnt = this.likeCnt - 1;
        this.updateChoice();
        return;
      }
      this.choice = 'like';
      this.likeCnt = this.likeCnt + 1;
      this.updateChoice();
    },
    fnUnlike() {
      if (this.choice === 'like') {
        this.likeCnt = this.likeCnt - 1;
      }
      if (this.choice === 'hate') {
        this.choice = '';
        this.hateCnt = this.hateCnt - 1;
        this.updateChoice();
        return;
      }
      this.choice = 'hate';
      this.hateCnt = this.hateCnt + 1;
      this.updateChoice();
    },
    async updateChoice() {
      const data = {
        like: this.choice === 'like' ? 1 : 0,
        hate: this.choice === 'hate' ? 1 : 0,
        review_id: this.review.id,
        store_id: this.review.storeId || this.storeId,
        user_id: this.loginUserId,
      };
      await this[reviewTypes.UPDATE_REVIEW_CHOICE_COUNT](data);
    },
    getReviewTypes() {
      if (this.review.reviewInternet === 1) this.reviewTypes.push('인터넷상담');
      if (this.review.reviewMobile === 1) this.reviewTypes.push('휴대폰상담');
      if (this.review.reviewVisit === 1) this.reviewTypes.push('매장방문');
      if (this.review.reviewNormal === 1) this.reviewTypes.push('일반상담');
    },
    colorWord(content) {
      if (this.isSearchPage) {
        const keyword = this.$route.query.keyword;
        return setKeyword(content, keyword);
      }
      return content;
    },
    goToStore(storeId) {
      this.$router.push({
        name: 'Shops.Detail',
        params: { id: storeId },
      });
    },
    getProfileNum(userId) {
      return setProfile(userId);
    },
  },
};
